import { render, staticRenderFns } from "./ReadAssay.vue?vue&type=template&id=b7f02ba2&"
import script from "./ReadAssay.vue?vue&type=script&lang=ts&"
export * from "./ReadAssay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports